// extracted by mini-css-extract-plugin
export default {"buttonLoading":"payment-deductions-item-action-button_buttonLoading__33592","button":"payment-deductions-item-action-button_button__5ed3d"};